<template>
  <FilterButton :title="title" @close="save" :active="selectedTypes.length > 0" data-test="coverage-type-filter">
    <template #menu="{ close }">
      <div class="menu">
        <h4>All Coverage Types</h4>
        <div class="columns">
          <label class="filter-item" v-for="type in coverageTypes" :key="type.text">
            <input type="checkbox" v-model="selectedTypes"  :value="type.value" data-test="filter-item-coverage-type-checkbox"/>
            <span>{{ type.text }}</span>
          </label>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="outlined" @click="clear" data-test="filter-coverage-type-clear">Clear</v-btn>
          <span>
            <v-btn class="mr8" variant="flat" size="small" color="secondary"
                   @click="selectAll" data-test="filter-coverage-type-select-all">Select All</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="close" data-test="filter-coverage-type-apply">Apply</v-btn>
          </span>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script>
import FilterButton from '@/components/FilterButton';

export default {
  name: 'CoverageTypeFilter',
  components: { FilterButton },
  props: {
    modelValue: Array,
    coverageTypes: Array
  },
  data() {
    return {
      dirty: false,
      selectedTypes: []
    };
  },
  computed: {
    title() {
      if (this.selectedTypes.length === 1) {
        return this.selectedTypes[0];
      }
      return 'Coverage Type';
    }
  },
  methods: {
    clear() {
      this.selectedTypes = [];
    },
    save() {
      if (this.dirty) {
        this.dirty = false;
        this.$emit('update:modelValue', this.selectedTypes);
      }
      return true;
    },
    selectAll() {
        this.selectedTypes = this.coverageTypes.map(x => x.value);
    }
  },
  watch: {
    selectedTypes() {
      this.dirty = true;
      this.$emit('input', this.selectedTypes);
    },
    modelValue() {
      this.selectedTypes = [...this.modelValue];
    }
  }
};
</script>

<style scoped>
.mr8 {
  margin-right: 8px;
}

.menu {
  padding: 1rem 0 0 0;
  min-width: 500px;
}

.menu > h4 {
  padding: 0 1rem;
}

.menu > .columns {
  padding: 0.5rem;
  margin: 0.5rem 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-column-gap: 4rem;
  max-height: 300px;
  overflow-y: scroll;
  border: 1px solid var(--v-border-base);
}

.menu > .columns > label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-content: center;
  align-items: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu > .buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: space-between;
}
</style>
